'use client';

import { useCallback } from 'react';

declare global {
  const FB: any;
  interface Window {
    fbAsyncInit: () => void;
  }
}

/**
 * Simplified Facebook SDK hook
 * Only provides logout functionality - login is handled via OAuth redirect
 */
export const useFacebookSDK = () => {
  const logoutFromFacebook = useCallback(() => {
    return new Promise<void>((resolve) => {
      if (typeof FB !== 'undefined') {
        try {
          // Add timeout for logout process
          const logoutTimeout = setTimeout(() => {
            console.warn('Facebook logout timeout - resolving anyway');
            resolve();
          }, 5000); // 5 seconds timeout

          // First check if user is logged in before attempting logout
          (FB as any).getLoginStatus((response: any) => {
            if (response.status === 'connected') {
              // User is logged in, proceed with logout
              const logoutProcessTimeout = setTimeout(() => {
                clearTimeout(logoutTimeout);
                resolve();
              }, 3000); // 3 seconds timeout for logout process

              try {
                (FB as any).logout(() => {
                  clearTimeout(logoutTimeout);
                  clearTimeout(logoutProcessTimeout);
                  resolve();
                });
              } catch (logoutError) {
                clearTimeout(logoutTimeout);
                clearTimeout(logoutProcessTimeout);
                console.warn('Facebook logout failed:', logoutError);
                resolve();
              }
            } else {
              // User is not logged in, no need to logout
              clearTimeout(logoutTimeout);
              resolve();
            }
          });
        } catch (error) {
          console.warn('Facebook getLoginStatus failed:', error);
          resolve();
        }
      } else {
        resolve();
      }
    });
  }, []);

  return {
    logoutFromFacebook,
  };
};
